class Config {
  constructor () {
    this.hostname = window.location.hostname
    this.local = this.hostname.includes("local")
  }

  socketServer () {
    return process.env.REACT_APP_SOCKET_URL || `${this.hostname}:3002`
  }
  
  remote() {
    return process.env.REACT_APP_REMOTE_URL || `${this.hostname}:3001`
  }

  isDebug() {
    return process.env.REACT_APP_DEBUG === 'true'
  }

  isProd() {
    return process.env.REACT_APP_ENVIRONMENT === 'prod'
  }

  url() {
    return window.location.href
  }
  
  isMuted() {
    return process.env.REACT_APP_MUTE === 'true'
  }

}

export default new Config()